export default __webpack_public_path__ + "static/media/CombineLogo.3a844cb4.jpg";